import React from 'react';
import ReadResume from './Read';
import WriteResume from './Write';

export default function Resume(props) {
  const { isUpdate, inputChange, dataProduct, setOpen, setDataProduct } = props; //data Products

  return isUpdate ? (
    <WriteResume inputChange={inputChange} dataProduct={dataProduct} setOpen={setOpen} setDataProduct={setDataProduct} />
  ) : (
    <ReadResume dataProduct={dataProduct} setOpen={setOpen} />
  );
}
